import { memo } from "react";
import "./ChatFooterDisclosureStyles.css";
import { display } from "../utils/displayValues";

const ChatFooterDisclosure = () => <p className="chat-footer-disclosure">{display.en.footerDisclosure}</p>;

export default memo(ChatFooterDisclosure);
